import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { Affectation } from '../model/affectation';

@Injectable({
    providedIn: 'root'
  })
  export class AffectationService{
  
    constructor(private _restClientService : RestClientService) 
    {}
    
    getAllAffectations() 
    {
        return this._restClientService.load<Affectation[]>('affectation/get');
    }
    
    getAffectationsByTaskId(taskId)
    {
        return this._restClientService.load<Affectation[]>('affectation/get-by-task/'+taskId);
    }
  
    getAffectationById(affectationId)
    {
        return this._restClientService.load<Affectation>('affectation/get/'+affectationId);
    }
        
    update(affectation) {
        return  this._restClientService.put<Affectation>(`affectation/update`, affectation);
    }
   
    add(affectation) {
        return  this._restClientService.save<Affectation>('affectation/add', affectation);
    }
  
    delete(affectationId) 
    {
        return this._restClientService.delete<any>('affectation/delete/'+affectationId);
    }
  




}      

    